import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../utils/AuthContext";

export default function ButtonAppBar() {
  const { signout, appUser } = useAuth()
  const navigate = useNavigate();

  const handleSubmit = async (e: React.MouseEvent<HTMLElement>) => {
    await signout().then(() => {
      navigate('/signin')
    }).catch((error) => {
      // An error happened.
      console.error("Logout error: ", error);
    });
  }

  return (

    <AppBar position="static">
      <Toolbar>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>
        <h3>
          My React App
        </h3>
        <Button color="inherit" onClick={() => navigate("addarticle")}>Add Article</Button>
        <Button color="inherit" onClick={() => navigate("articlelist")}>Articles</Button>
        <Button color="inherit">
          {(appUser && appUser.user) &&
            <div>  {appUser.user.email}!</div>}
        </Button>
        <Button color="inherit" onClick={(e: React.MouseEvent<HTMLElement>) => handleSubmit(e)}>
          Logout
        </Button>
      </Toolbar>
    </AppBar>

  );
}